import { createTranslations } from '@npco/utils-translations'

export const cardSpendProgressCellTranslations = createTranslations({
  tooltipRemaining: '{percentage}% Remaining',
  tooltipSpend: '{amount} Spent',
})
